import { Card, Chat1LineIcon, Col, InfinityLoading, Row, Skeleton } from 'ui';
import { useTransactionItemsInfiniteQuery } from 'features/transactions';
import { Testimonial } from './testimonial';

type P = {
  givingId: string;
};

const Testimonials = ({ givingId }: P) => {
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useTransactionItemsInfiniteQuery({
    filter: { order: 'created_at', subjectId: givingId, subjectType: 'Giving', testimonials: true },
    pagination: { pageSize: 12 },
  });

  const allTestimonials = data?.pages.flat().flatMap((givingsPaginated) => givingsPaginated.data);

  return (
    <>
      {isLoading ? (
        <Skeleton paragraph={{ rows: 6 }} />
      ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
      allTestimonials?.length ? (
        <Card title={<Card.Title icon={<Chat1LineIcon />}>Testimonials</Card.Title>}>
          <Row gutter={[0, 'ms']}>
            {allTestimonials.map((testimonial) => (
              <Col key={testimonial.id} span={24}>
                <Testimonial testimonial={testimonial} />
              </Col>
            ))}
          </Row>

          <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
        </Card>
      ) : null}
    </>
  );
};

export default Testimonials;
